/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { PopoverProps } from './Popover.props';

export const Popover = ({ children, position = 'top', content, title, size = 'small' }: PopoverProps): JSX.Element => {
  return (
    <div
      className={clsx('sds-popover', {
        [`sds-popover--${position}`]: position,
        [`sds-popover--${size}`]: size,
      })}
    >
      {children}
      <div className="sds-popover__content-wrapper">
        <div className="sds-popover__content">
          {title && <p className="sds-popover__title">{title}</p>}
          <div className="sds-popover__text">{content}</div>
        </div>
      </div>
    </div>
  );
};
